import Login from '@Pages/auth/Login/Login'
import CreateProfileStep1 from '@Pages/auth/Register/CreateProfileStep1'
import CreateProfileStep2 from '@Pages/auth/Register/CreateProfileStep2'
import Register from '@Pages/auth/Register/Register'
import Dashboard from '@Pages/Client/dashboard/dashboard'
import addFirearm from '@Pages/Client/firearm/add-firearm/add-firearm'
import detailFirearm from '@Pages/Client/firearm/detail-firearm/detail-firearm'
import firearm from '@Pages/Client/firearm/firearm'
import myAccount from '@Pages/Client/my-account/my-account'
import receipt from '@Pages/Client/my-account/receipt/receipt'
import statement from '@Pages/Client/my-account/statement/statement'
import ClientRoute from '@Routes/ClientRoute'
import AmmunitionList from '@Pages/Client/ammunition/ammunition'
import { Redirect, Route, Switch } from 'react-router'
import mySafeStorage from '@Pages/Client/my-safe-storage/my-safe-storage'
// eslint-disable-next-line max-len
import firearmsAnomalyResolution from '@Pages/Client/firearms-anomaly-resolution/firearms-anomaly-resolution'
import contact from '@Pages/Client/contact/contact'
import insurance from '@Pages/Client/insurance/insurance'
import disposeOfFirearm from '@Pages/Client/dispose-of-firearm/dispose-of-firearm'
import myVault from '@Pages/Client/my-vault/my-vault'
import inspection from '@Pages/Client/inspection/inspection'
import profile from '@Pages/Client/profile/profile'
import EducatorRoute from '@Routes/EducatorRoute'
import educatorInfo from '@Pages/Educator/educator-info/educator-info'
import InspectionRoute from '@Routes/InspectionRoute'
import inspectionInfo from '@Pages/Inspection/inspection-info/inspection-info'
import MedicalRoute from '@Routes/MedicalRoute'
import medicalInfo from '@Pages/Medical/medical-info/medical-info'
import notFound from '@Pages/404/not-found'
import ReportInfo from '@Pages/Report/report-info'
import ReportDetail from '@Pages/Admin/report/detail/ReportDetail'
import Report from '@Pages/Admin/report/Report'
import AdminReportRoute from '@Routes/AdminReportRoute'
import ReportRoute from './ReportRoute'

function AppRouting() {
    return (
        <>
            {/* auth-routing */}
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route
                exact
                path="/create-profile-step-1"
                component={CreateProfileStep1}
            />
            <Route
                exact
                path="/create-profile-step-2"
                component={CreateProfileStep2}
            />
            <Switch>
                {/* client-routing */}
                <Route
                    exact
                    path="/"
                    render={() => <Redirect to="/dashboard" />}
                />
                <ClientRoute exact path="/dashboard" component={Dashboard} />
                <ClientRoute exact path="/firearms" component={firearm} />
                <ClientRoute
                    exact
                    path="/detail-firearm/:id"
                    component={detailFirearm}
                />
                <ClientRoute exact path="/add-firearm" component={addFirearm} />
                <ClientRoute exact path="/my-account" component={myAccount} />
                <ClientRoute
                    exact
                    path="/my-account/statement"
                    component={statement}
                />
                <ClientRoute
                    exact
                    path="/my-account/receipt"
                    component={receipt}
                />
                <ClientRoute
                    exact
                    path="/ammunition"
                    component={AmmunitionList}
                />
                <ClientRoute
                    exact
                    path="/my-safe-storage"
                    component={mySafeStorage}
                />
                <ClientRoute
                    exact
                    path="/firearms-anomaly-resolution"
                    component={firearmsAnomalyResolution}
                />
                <ClientRoute exact path="/contact" component={contact} />
                <ClientRoute exact path="/insurance" component={insurance} />
                <ClientRoute
                    exact
                    path="/dispose-of-firearm"
                    component={disposeOfFirearm}
                />
                <ClientRoute exact path="/my-vault" component={myVault} />
                <ClientRoute exact path="/inspection" component={inspection} />
                <ClientRoute exact path="/settings" component={profile} />

                {/* educator-routing */}
                <EducatorRoute exact path="/home" component={educatorInfo} />
                <EducatorRoute
                    exact
                    path="/educator-info"
                    component={educatorInfo}
                />

                {/* inspection-routing */}
                <InspectionRoute
                    exact
                    path="/inspection-info"
                    component={inspectionInfo}
                />

                {/* medicator-routing */}
                <MedicalRoute
                    exact
                    path="/medical-home"
                    component={medicalInfo}
                />

                {/* report */}
                <ReportRoute exact path="/report" component={ReportInfo} />
                {/* admin */}

                {/* admin report */}
                {/* <ReportRoute exact path="/admin/report" component={Report} />
                <ReportRoute
                    exact
                    path="/admin/report/:id"
                    component={ReportDetail}
                /> */}
                <AdminReportRoute
                    exact
                    path="/admin/report"
                    component={Report}
                />
                <AdminReportRoute
                    exact
                    path="/admin/report/:id"
                    component={ReportDetail}
                />

                {/* not-found */}
                <Route exact path="" component={notFound} />
            </Switch>
        </>
    )
}

export default AppRouting
